import React from 'react';
const Footer: React.FC = () => {
    return (
        <footer>
            <span>© 2021 PersonalFinances.eu</span>
        </footer>
    );
};
export default Footer;
